import Service from "./Service";
import {
  BankAccountEntity,
  BillLogEntity,
  CreditModuleEntity,
  TradeBillEntity,
  TradeTemplateEntity,
  TradeRoleEntity,
  TradePriceEntity,
  TradeOrderEntity,
  TradeFreezeEntity,
  TradeFlowEntity,
  ListPages,
  TradeDetailEntity,
  TradeModel,
  TradeDealEntity,
  ListPageBill,
  TradeAccountEntity,
} from "../model/Bill";
class billService extends Service {
  cashier(data: any) {
    return this.post<any>(`/trade/cashier`, data);
  }
  redirect(data: any) {
    return this.post<any>(`/trade/redirect`, data);
  }
  getTradeDeals(UniqueID: string) {
    return this.get<TradeDealEntity[]>(`/TradeDeal/GetTradeDeals?UniqueID=${UniqueID}`);
  }
  GetUserPayment(orderid: string, unionid: string) {
    return this.get<TradeDealEntity[]>(`/TradeDeal/GetUserPayment?OrderID=${orderid}&UnionID=${unionid}`);
  }
  getUserTicketStatus(data: TradeDetailEntity) {
    return this.post<TradeDetailEntity[]>("/tradedetail/SearchUserTicket", data);
  }
  getPayStatus(PackageID: string) {
    return this.get<TradeDetailEntity[]>(`/TradeOrder/Details?id=${PackageID}`);
  }
}
export default new billService("bill");
